import { Amplify } from "aws-amplify";

// Basic Amplify configuration
// You'll need to replace these with your actual AWS Cognito settings
const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || "us-east-1_example",
      userPoolClientId: import.meta.env.VITE_COGNITO_USER_WEB_CLIENT_ID || "example-client-id",
      region: import.meta.env.VITE_AWS_REGION || "us-east-1",
      // Optional: for advanced use cases
      // identityPoolId: import.meta.env.VITE_AWS_IDENTITY_POOL_ID,
      // loginWith: {
      //   oauth: {
      //     domain: import.meta.env.VITE_AWS_OAUTH_DOMAIN,
      //     scopes: ['email', 'openid', 'profile'],
      //     redirectSignIn: window.location.origin + '/auth-callback',
      //     redirectSignOut: window.location.origin + '/auth-test',
      //     responseType: 'code'
      //   }
      // }
    },
  },
};

// Configure Amplify
Amplify.configure(amplifyConfig);

export default amplifyConfig;

